import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentAttendee: {},
  newAttendee: {},
  isAcceptCollectPersonalInfo: true,
  loading: false,
  error: null,
};

const attendeeSlice = createSlice({
  name: "attendee",
  initialState,

  reducers: {
    resetState: (state, action) => {
      const fieldName = action.payload;
      state[fieldName] = initialState[fieldName];
    },
    resetAttendeeInfo: state => {
      state.currentAttendee = {};
      state.newAttendee = {};
      state.isAcceptCollectPersonalInfo = true;
    },
    resetAttendeeInfoOtherThanIsAcceptCollectPersonalInfo: state => {
      state.currentAttendee = {};
      state.newAttendee = {};
    },
    actionSetNewAttendeeInfo: (state, action) => {
      state.newAttendee = {
        ...state.newAttendee,
        ...action.payload,
      };
      state.loading = false;
      state.error = {};
    },
    actionSetCurrentAttendeeInfo: (state, action) => {
      state.currentAttendee = {
        ...state.currentAttendee,
        ...action.payload,
      };
      state.loading = false;
      state.error = {};
    },
    toggleCheckbox: state => {
      state.isAcceptCollectPersonalInfo = !state.isAcceptCollectPersonalInfo;
    },
  },
});

export const {
  resetState,
  actionSetNewAttendeeInfo,
  actionSetCurrentAttendeeInfo,
  resetAttendeeInfo,
  resetAttendeeInfoOtherThanIsAcceptCollectPersonalInfo,
  toggleCheckbox,
} = attendeeSlice.actions;
const { reducer: attendeeReducer } = attendeeSlice;
export default attendeeReducer;
